(function ($) {
  $(function () {
    var quoteCarouselWrapper = $('.quote-carousel__wrapper');

    if (quoteCarouselWrapper.length) {
      quoteCarouselWrapper.each(function () {
        if ($(this).find('.quote').length > 1) {
          $(this).slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 8000,
            fade: true,
            swipe: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            slidesToSwipe: 1,
            arrows: false,
            adaptiveHeight: true,
            dots: true,
          });
        }
      });
    }
  });
})(jQuery);


